import APP_ROUTES from "@app/common/routes";

import Config from "./config.js";

const APP_BASE_URL = Config.HOST || "https://app.read.ai";

const POPUP_ROUTES = {
  SETTINGS: "/settings",
  SIGN_IN: "/signin",
  TUTORIAL: "/tutorial",
};

const EXTERNAL_ROUTES = {
  SIGN_IN: `${APP_BASE_URL}${APP_ROUTES.SIGN_IN}`,
  SIGN_UP: `${APP_BASE_URL}${APP_ROUTES.SIGN_UP}`,
  SIGN_OUT: `${APP_BASE_URL}${APP_ROUTES.SIGN_OUT}`,

  CALENDAR: `${APP_BASE_URL}${APP_ROUTES.CALENDAR}`,
  CONNECT_CALENDAR: `${APP_BASE_URL}${APP_ROUTES.USER_SETTINGS_INTEGRATIONS}`,
  DASHBOARD: `${APP_BASE_URL}${APP_ROUTES.LANDING_PAGE}`,
  JOIN_PREFERENCES_SETTINGS: `${APP_BASE_URL}${APP_ROUTES.USER_SETTINGS_JOIN_PREFERENCES}`,
  MEETING_REPORTS: `${APP_BASE_URL}${APP_ROUTES.MEETING_REPORTS}`,
  RECOMMENDATIONS: `${APP_BASE_URL}${APP_ROUTES.RECOMMENDATIONS}`,
  USER_SETTINGS: `${APP_BASE_URL}${APP_ROUTES.USER_SETTINGS_DEFAULT_SECTION}`,
  LANDING_PAGE: `${APP_BASE_URL}${APP_ROUTES.LANDING_PAGE}`,
};

const PARAMETERIZED_EXTERNAL_ROUTES = {
  meetingReportById: (id: string) =>
    `${APP_BASE_URL}${APP_ROUTES.meetingReportById(id)}`,
  recommendationById: (id: string) =>
    `${APP_BASE_URL}${APP_ROUTES.recommendationById(id)}`,
};

const ROUTES = {
  POPUP: POPUP_ROUTES,
  ...EXTERNAL_ROUTES,
  ...PARAMETERIZED_EXTERNAL_ROUTES,
};

export default ROUTES;
